export default {
    path: "/login",
    name: "Login",
    component: () => import(/* webpackChunkName: "abuout" */ '../../views/login/login.vue')
}